import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useGetScenarioShortSummaryQuery = (
  workspaceId?: string,
  prototypeId?: string,
  
) => {
  const { prototypes } = useAvApi();

  const data = useQuery({
    enabled: !!workspaceId || !prototypeId,
    queryKey: ['scenario-short-summary', prototypeId],
    queryFn: async () => {
      if (!prototypeId || !workspaceId) return;
      const data =
        await prototypes.getV2ProjectsPrototypesReportShortByProjectIdAndPrototypeId(
          { projectId: workspaceId, prototypeId }
        );

      return data.data;
    },
  });

  return data;
};
